<template>
  <header class="archive-hero catalog-hero">
    <div>
      <h1 class="editorial-display">{{ title }}</h1>
      <p v-if="description" class="editorial-dek">{{ description }}</p>
      <div v-if="$slots.default" class="page-header-content"><slot /></div>
    </div>
    <Image :src="image" :alt="alt" class="archive-collage" />
  </header>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  description?: string
  image: string
  alt: string
}>()
</script>
